import * as React from "react";
import * as moment from "moment";


interface Props {
    slots?: any[];
    onChangeMonth?: Function;
}

interface State {
    date?: moment.Moment;
}

export default class Calendario extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
          date: moment()
        };
    }
    
    parseSlots() {
        const { slots = [] as any } = this.props;
        var items = [] as any;
        // divide in weeks
        slots.forEach( s => {
            let weeks = [] as any;
            let current = s.start.clone();
            // collect weeks numbers for this slot
            while (current.isBefore(s.end)) {
                const w = current.format('W');
                if (weeks.indexOf(w) === -1) {
                    weeks.push( w );
                }
                current.add(1, 'days');
            }
            weeks.forEach( w => {
                items.push({
                    ...s,
                    w
                })
            })
        });
        return items;
    }
    
    build() {
        const { date } = this.state;
        const weekdays = moment.weekdaysShort(true);
        const first = date!.clone().startOf('month').weekday(0); // first of month, last monday
        const last = date!.clone().endOf('month').weekday(6); // last of month, last sunday
        let weeks = [];
        let current = first.clone();
        while (current.isBefore(last)) {
            const w = current.format('W');
            if (!weeks[w]) { weeks[w] = []; }
            weeks[w].push( current.clone() );
            current.add(1, 'days');
        }
        return {
            weekdays,
            weeks
        };
    }
    
    navMonth( dir ) {
        const { onChangeMonth } = this.props;
        const { date } = this.state;
        const newDate = date!.clone()[dir > 0 ? "add" : "subtract"](1, 'months');
        this.setState({
            date: newDate
        });
        if (onChangeMonth) {
            onChangeMonth( newDate );
        }
    }
  
    render() {
        const { } = this.props;
        const { date } = this.state;
        const { weekdays, weeks } = this.build();
        const slots = this.parseSlots();
        
        return (
          <div className="UI_Calendario">
            <nav>
                <button className="cancel onlyicon" onClick={() => this.navMonth(-1)}><span className="icon-big-prev" /></button>
                <span>{date!.format('MMMM YYYY')}</span>
                <button className="cancel onlyicon" onClick={() => this.navMonth(1)}><span className="icon-big-next" /></button>
            </nav>
            <header>
                {weekdays.map( (day,i) => (
                <div key={i}>{day}</div>   
                ))}
            </header>
            <div className="body">
                {weeks.map( (days,w) => (
                <div className="week" key={w}>
                    <div className="days">
                        {(days as any).map( (day, i) => {
                        const disabled = (day.month() !== date!.month());
                        return (
                        <div key={i} className={disabled ? 'disabled' : ''}>
                            {day.format('D')}
                        </div>
                        )
                        })}
                    </div>
                    {slots.filter(s => { return parseInt(s.w) === (w) } ).map( (s,i) => {
                        return s.component;
                    })}
                </div>
                ))}
            </div>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/Calendario.tsx